import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnFilterClickGeneral(props) {
  let current = useDataValue({
    context: 'tab',
    path: 'selected.ledger.notes.filter_by',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'tab',
    path: 'selected.ledger.notes.filter_by',
    viewPath: props.viewPath,
  })

  return function onClick() {
    if (current.length === 0) {
      change(['general'])
      return
    }

    if (current.includes('general')) {
      let newSelected = current.filter(item => item !== 'general')
      change(newSelected)
    } else {
      change([...current, 'general'])
    }
  }
}

export function getCount(notes, type) {
  return notes.filter(item => item.type === type).length
}
